import { Text } from 'components/Ui-Kits/Text'
import { useAppTranslation } from 'i18n/hooks'
import { any, bool, number } from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components'

export const HighestBidBox = ({ bid, hasBids, amount }) => {
  const { t } = useAppTranslation()

  const bidLabel = useMemo(() => {
    if (!hasBids) return t('startingPrice')

    return t('currentHighestBid')
  }, [hasBids, t])

  const bidDescription = useMemo(() => {
    if (!bid) return t('youHaveNotBidded')
    if (!bid.isWinning) return t('yourBidIsntWinning', { amount: bid.amount })

    return t('yourBidIsWinning', { amount: bid.amount })
  }, [bid, t])

  return (
    <Wrap>
      <TextWrap align="center">
        <Text color="primary" bold>
          {bidLabel}
        </Text>
        <Text color="primary" bold aria-setsize={1.375}>
          {amount} €
        </Text>
      </TextWrap>
      <TextWrap align="center">
        {!!bid && <Circle color={bid.isWinning ? 'green2' : 'primary'} />}
        {(hasBids || !!bid) && (
          <IconTextWrap bold color={bid?.isWinning ? 'green2' : 'black'}>
            {bidDescription}
          </IconTextWrap>
        )}
        {!hasBids && <IconTextWrap>&nbsp;</IconTextWrap>}
      </TextWrap>
    </Wrap>
  )
}

HighestBidBox.propTypes = {
  bid: any,
  hasBids: bool,
  amount: number,
}

const TextWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify = 'space-between' }) => justify};
  align-items: ${({ align = 'flex-start' }) => align};
  margin-bottom: ${({ noMargin }) => !noMargin && '1rem'};
`
const IconTextWrap = styled(Text)`
  flex: 1;
`

const Circle = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.375rem;
  background-color: var(--color-${({ color }) => color});
  margin-right: 0.375rem;
`
const Wrap = styled.div`
  width: 100%;
  padding: 0.5625rem 1rem;
  border: 1px solid var(--color-primary);
  margin-bottom: 1rem;

  ${TextWrap} {
    margin-bottom: 0.3125rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`
